import styled, { css } from "styled-components";

const baseTextStyles = css`
  color: #fff;
  text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5), 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const Title = styled.h1`
  ${baseTextStyles};
  font-size: 2.5rem;
  @media (min-width: 768px) {
    font-size: 3.75rem;
  }
`;

export default Title;
